<template>
  <div class="relative" id="wishTree">
    <img
      src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Group 3522.png"
      alt="tree"
      class="tree_img lg:object-contain object-cover lg:pt-0 md:pt-0 pt-20"
    />
    <div class="absolute top-0 left-0 w-full tree_img flex items-center">
      <div class="lg:w-7/12 md:w-4/5 w-11/12 mx-auto lg:mt-0 md:mt-0 mt-14">
        <div class="example-3d">
          <swiper
            :loop="true"
            class="swiper"
            ref="mySwiper"
            :options="swiperOptions"
          >
            <swiper-slide
              class="cursor-pointer"
              v-for="(i, index) in wishData"
              :key="index"
            >
              <div
                class="w-full p-2 cust-bg hover_card h-full flex justify-center items-center"
              >
                <div
                  class="tree"
                  @mouseover="mouseover(i)"
                  @mouseleave="mouseleave(i)"
                >
                  <p
                    class="clr777 font-semibold fsize14 sm-fsize12 italic mb-3"
                  >
                    {{ i.title }}
                    <!-- :
                    {{ i.numOfViews ? i.numOfViews : 0 }} -->
                  </p>
                  <p class="clr777 font-normal fsize14 sm-fsize12 italic mb-3">
                    {{ i.description }}
                  </p>

                  <p
                    class="w-1/2 mx-auto rounded-sm fsize12 bg-primary px-2 py-1"
                    style="display: inline; cursor: pointer"
                    @click="DonatePage(i)"
                    v-if="showPrice"
                  >
                    Rs.{{ i.price }}
                  </p>
                  <p
                    class="w-1/2 mx-auto rounded-sm fsize12 bg-primary px-2 py-1"
                    style="display: inline; cursor: pointer"
                    @click="DonatePage(i)"
                    v-else
                  >
                    Fullfill wish!
                  </p>
                </div>
              </div>
            </swiper-slide>
            <!-- <swiper-slide class="cursor-pointer">
              <div
                class="w-full lg:px-2 md:px-2 px-2 cust-bg hover_card h-full flex items-center"
              >
                <div class="" @mouseover="mouseover" @mouseleave="mouseleave">
                  <p class="clr777 font-normal fsize14 sm-fsize12 italic">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Laboriosam, in. Lorem ipsum dolor sit amet consectetur
                    adipisicing elit. Laboriosam, in.
                  </p>
                  <p
                    class="w-1/2 mx-auto rounded-sm fsize12 mt-3 bg-primary px-2 py-1"
                  >
                    Fullfill wish!
                  </p>
                </div>
              </div>
            </swiper-slide>
            <swiper-slide class="cursor-pointer">
              <div
                class="w-full lg:px-2 md:px-2 px-2 cust-bg hover_card h-full flex items-center"
              >
                <div class="" @mouseover="mouseover" @mouseleave="mouseleave">
                  <p class="clr777 font-normal fsize14 sm-fsize12 italic">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Laboriosam, in. Lorem ipsum dolor sit amet consectetur
                    adipisicing elit. Laboriosam, in.
                  </p>
                  <p
                    class="w-1/2 mx-auto rounded-sm fsize12 mt-3 bg-primary px-2 py-1"
                  >
                    Fullfill wish !
                  </p>
                </div>
              </div>
            </swiper-slide> -->

            <!-- <div
              class="swiper-pagination cust-posi"
              slot="pagination"
              id="paginationdots2"
            ></div> -->
          </swiper>
        </div>
      </div>
    </div>
    <div class="absolute lg:top-12 top-3 lg:left-12 left-3 lg:px-20">
      <p class="fsize20 sm-fsize16 font-semibold">Select a Wish to</p>
      <h2 class="fsize36 sm-fsize24 text-primary font-semibold">
        Make it happen !
      </h2>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from "vuex";
import "swiper/dist/css/swiper.min.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        effect: "coverflow",
        grabCursor: true,
        centeredSlides: true,
        // slidesPerView: 3,
        spaceBetween: 170,

        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        roundLengths: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 150,
          modifier: 3,
          slideShadows: true,
        },
        breakpoints: {
          1600: {
            slidesPerView: 2.1,
            spaceBetween: 100,
          },
          1300: {
            slidesPerView: 2.1,
            spaceBetween: 100,
          },
          820: {
            slidesPerView: 2.1,
            spaceBetween: 80,
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 40,
          },
          505: {
            slidesPerView: 1.3,
            spaceBetween: 80,
          },
        },
        pagination: {
          el: "#paginationdots2",
        },
      },
      isDetailsActive: false,
      wishData: [],
      showPrice: false,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    ...mapState("testimonial", {
      testimonials: "testimonial",
      redirect: "redirect",
    }),
  },
  methods: {
    DonatePage(ITEM) {
      console.log(ITEM, "ITM Slected");
      let donateURL = "https://pages.razorpay.com/caregiversaathi-donation";
      let donatePage = `${donateURL}?amount=${ITEM.price}`;
      window.open(donatePage);
    },
    handleLeave(val = false, item = {}) {
      if (!sessionStorage.getItem("token")) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      // console.log("Click");
      this.isLeaveActive = val;
      this.selectTesimonial = item;
    },
    toggleDetails(val = false, item = {}) {
      // console.log("Click");
      this.isDetailsActive = val;
      this.selectedTesimonial = item;
    },
    mouseover(ITEM) {
      // this.swiper.autoplay.pause();
      this.showPrice = true;
      // this.wishData.forEach((element) => {
      //   if (ITEM._id === element._id) {
      //     element.showPrice = true;
      //   }
      // });
    },
    mouseleave(ITEM) {
      // console.log("Leave");
      // this.swiper.autoplay.run();
      this.showPrice = false;
      // this.wishData.forEach((element) => {
      //   if (ITEM._id === element._id) {
      //     element.showPrice = false;
      //   }
      // });
    },
    async getAllTestimonial() {
      let loader;
      try {
        let payload = {
          limit: 50,
          status: "Accept",
        };
        // loader = this.$loading();
        const allTestimonial = await this.$store.dispatch(
          "testimonial/getAllTestimonial",
          payload
        );

        // loader.close();

        // console.log(this.testimonials);
      } catch (error) {
        console.log(error);
        // loader.close();
      }
    },
    async handleGet() {
      let payload = { pagination: false };
      let result = await this.$store.dispatch("services/getWishes", payload);
      console.log(result, "RESULT");
      // this.wishData = result.data.data;
      this.wishData = result.data.data.map((x) => {
        return {
          ...x,
          showPrice: false,
        };
      });
    },
  },
  async mounted() {
    // console.log(this.redirect, "redirect");
    if (this.redirect === true) {
      const el = document.getElementById("testimonialjoinus");
      // console.log(el, "el");
      el.scrollIntoView({ behavior: "smooth", block: "center" });
      this.$store.commit("testimonial/REDIRECT_TESTIMONIAL", false);
      // console.log(this.redirect, "redirect");
    }
    await this.getAllTestimonial();
    await this.handleGet();
  },
};
</script>

<style lang="scss" scoped>
.example-3d {
  width: 100%;
}

.swiper {
  height: 100%;
  width: 100%;

  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 400px;
    height: 220px;
    text-align: center;
    font-weight: bold;
    font-size: 15px;
    background-position: center;
    background-size: cover;
    color: white;
    border: 6px solid #e9ddfa;
    border-radius: 25px;
    background-color: white !important;

    @media (max-width: 820px) and (min-width: 526px) {
      height: 220px !important;
    }

    @media (max-width: 525px) {
      height: 160px !important;
    }
  }

  .swiper-pagination {
    .swiper-pagination-bullet.swiper-pagination-bullet-active {
      background-color: white;
    }
  }
}
.border-user {
  border: 4px solid #0193a1;
  border-radius: 100%;
}
// .cust-bullet > .swiper-pagination-bullet {
// }
.cust-bullet > .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  display: inline-block;
  border-radius: 100%;
  background: #000;
  opacity: 0.2;
  margin-left: 3px !important;
  margin-right: 3px !important;
}
.cust-bg .swiper-container-3d .swiper-slide-shadow-right {
  background-image: -webkit-gradient(
    linear,
    left top,
    right top,
    from(rgba(146, 146, 146, 0.2)),
    to(rgba(0, 0, 0, 0))
  ) !important ;
  background-image: -webkit-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: -o-linear-gradient(
    left,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
  background-image: linear-gradient(
    to right,
    rgba(0, 0, 0, 0.5),
    rgba(0, 0, 0, 0)
  );
}
.cust-posi {
  position: initial !important;
  padding-top: 25px;
}

@media (max-width: 641px) {
  .cust-posi {
    padding-top: 10px !important;
  }
}
p.wquote::before {
  background-image: url("../../../assets/images/comma.png");
  content: "";
}
p.wquote::after {
  background-image: url("../../../assets/images/commaclose.png");
  content: "";
}

.swiper-slide:hover {
  background-color: #f4f5f6 !important;
}
</style>
